import { Component, EventEmitter, OnInit, Output } from '@angular/core'
import {
  FormBuilder,
  FormGroup,
  ReactiveFormsModule,
  Validators,
} from '@angular/forms'
import { MatButton } from '@angular/material/button'
import { MatProgressSpinner } from '@angular/material/progress-spinner'
import { SnackbarCustomService } from '../../../shared/components/snackbar/snackbar-custom.service'
import {
  ErrorRequestModel,
  ResponseRequestModel,
} from '../../../core/models/response.model'
import { MatFormField, MatLabel } from '@angular/material/form-field'
import { MatInput } from '@angular/material/input'
import { ServiceSpecificationService } from '../../../core/services/service/service-specification/service-specification.service'
import { MatSelectModule } from '@angular/material/select'
import { ServiceTypeService } from '../../../core/services/service/service-type/service-type.service'
import { MatSlideToggle } from '@angular/material/slide-toggle'
import { CurrencyInputDirective } from '../../../shared/directives/currencyInput'
import { IntegerInputDirective } from '../../../shared/directives/IntegerInput'
import { convertCurrency } from '../../../shared/utils/utils'

@Component({
  selector: 'service-specification-create',
  imports: [
    ReactiveFormsModule,
    MatButton,
    MatProgressSpinner,
    MatFormField,
    MatInput,
    MatLabel,
    MatSelectModule,
    MatSlideToggle,
    CurrencyInputDirective,
    IntegerInputDirective,
  ],
  templateUrl: './service-specification-create.component.html',
  styleUrl: './service-specification-create.component.scss',
  providers: [ServiceSpecificationService],
  standalone: true,
})
export class ServiceSpecificationCreateComponent implements OnInit {
  constructor(
    private formBuilder: FormBuilder,
    private serviceSpecificationService: ServiceSpecificationService,
    private serviceTypeService: ServiceTypeService,
    private snackbar: SnackbarCustomService,
  ) {}

  @Output() responseCreate = new EventEmitter()

  form: FormGroup = new FormGroup({})
  loading = false
  listType: any[] = []

  ngOnInit(): void {
    this.createForm()
    this.listTypeService()
  }

  listTypeService() {
    this.serviceTypeService.listServiceType().subscribe({
      next: (response: ResponseRequestModel) => {
        this.listType = response.data
      },
      error: (err: ResponseRequestModel) => {
        console.error(err)
      },
      complete: () => {},
    })
  }

  createItem() {
    this.loading = true
    const model = this.createModel()
    this.serviceSpecificationService
      .createServiceSpecification(model)
      .subscribe({
        next: (response: ResponseRequestModel) => {
          this.snackbar.success(response.message)
          this.responseCreate.emit()
        },
        error: (err: ErrorRequestModel) => {
          this.loading = false
          this.snackbar.errorRequest(err)
        },
        complete: () => {
          this.loading = false
          this.form.reset()
        },
      })
  }

  createModel() {
    let km = this.form.get('km')!.value
    let hour = this.form.get('hour')!.value
    if (km) {
      km = convertCurrency(km)
    } else {
      km = null
    }
    if (hour) {
      hour = parseInt(hour)
    } else {
      hour = null
    }

    return {
      descricao: this.form.controls['description'].value,
      tipoServicoId: this.form.controls['typeService'].value,
      exigeVeiculo: this.form.get('vehicle')!.value ? 'S' : 'N',
      km: km,
      hora: hour,
    }
  }

  createForm(): void {
    this.form = this.formBuilder.group({
      description: ['', [Validators.required]],
      typeService: ['', [Validators.required]],
      km: [''],
      hour: [''],
      vehicle: [''],
    })
  }
}
